import { Dispatch } from "react"
import { GETAPI, POSTAPI, POSTAPIFORMDATA, PDFPOSTAPI } from "../../Api/Api";
import { ApiConfig } from "../../Config/ApiConfig";
import { CODE } from "../../Constants/Constants";
import { DASHBOARD_GET_DATA } from "../../Constants/DashboardConstants"
import { renderFormData } from "../../utils/Helper";

// Common For Get Api Action
export const createGetDataAction = (typePrefix: string, apiEndpoint: string, payload: any, toastStatus: any = false) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: `${typePrefix}_RESET` });
    } else {
        try {
            dispatch({ type: `${typePrefix}_REQUEST` });
            let data = await GETAPI(apiEndpoint, payload, toastStatus);

            if (data && data?.status === true) {
                dispatch({
                    type: `${typePrefix}_SUCCESS`,
                    payload: data
                });
            } else {
                dispatch({
                    type: `${typePrefix}_FAIL`,
                    payload: data
                });
            }
        } catch (error: any) {
            dispatch({
                type: `${typePrefix}_FAIL`,
                payload: error.message
            });
        }
    }
};
// // Common For Post Api Action
export const createPostDataAction = (typePrefix: string, apiEndpoint: string, payload: any, toastStatus: any = false) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: `${typePrefix}_RESET` });
    } else {
        try {
            dispatch({ type: `${typePrefix}_REQUEST` });
            let data = await POSTAPI(apiEndpoint, payload, toastStatus);
            if (data && data?.status === true) {
                dispatch({
                    type: `${typePrefix}_SUCCESS`,
                    payload: data
                });
            } else {
                dispatch({
                    type: `${typePrefix}_FAIL`,
                    payload: data
                });
            }
        } catch (error: any) {

            dispatch({
                type: `${typePrefix}_FAIL`,
                payload: error.message
            });
        }
    }
};
// Common Form Action

export const createFormDataAction = (typePrefix: string, apiEndpoint: string, payload: any, toastStatus: any = false) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: `${typePrefix}_RESET` });
    } else {
        try {

            let payloadData: any
            if (payload instanceof FormData) {
                payloadData = payload
            } else {
                payloadData = await renderFormData(payload);
            }

            dispatch({ type: `${typePrefix}_REQUEST` });
            let data = await POSTAPIFORMDATA(apiEndpoint, payload, toastStatus);


            if (data && data?.status === true) {
                dispatch({
                    type: `${typePrefix}_SUCCESS`,
                    payload: data
                });
            } else {

                dispatch({
                    type: `${typePrefix}_FAIL`,
                    payload: data
                });
            }
        } catch (error: any) {
            dispatch({
                type: `${typePrefix}_FAIL`,
                payload: error?.message
            });
        }
    }
};


export const GetDashboardDataAction = (payload: any) => createPostDataAction(DASHBOARD_GET_DATA, ApiConfig?.DashboardGet, payload);



// // Common For Post/PDF Api Action
export const createPostDataPdfAction = (typePrefix: string, apiEndpoint: string, payload: any, toastStatus: any = false) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: `${typePrefix}_RESET` });
    } else {
        try {
            dispatch({ type: `${typePrefix}_REQUEST` });
            let data = await PDFPOSTAPI(apiEndpoint, payload, toastStatus);
            if (data && data?.status === CODE.CREATED) {
                dispatch({
                    type: `${typePrefix}_SUCCESS`,
                    payload: data
                });

            } else {
                dispatch({
                    type: `${typePrefix}_FAIL`,
                    payload: { message: "something went wrong" }
                });
            }

        } catch (error: any) {
            dispatch({
                type: `${typePrefix}_FAIL`,
                payload: error.message
            });
        }
    }
};

export const normalAction = (typePrefix: string, payload: any) => async (dispatch: Dispatch<any>) => {
    if (payload === 'RESET') {
        dispatch({ type: `${typePrefix}_RESET` });
    } else {
        try {
            dispatch({
                type: `${typePrefix}_SUCCESS`,
                payload: payload
            });

        } catch (error: any) {
            dispatch({
                type: `${typePrefix}_FAIL`,
                payload: error.message
            });
        }
    }
};

export const DashboardRedirectionAction = (payload: any) => normalAction('DASHBOARD_REDIRECTION', payload);
